/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AuthorBadgesContainer_settings = {
    readonly flairBadges: {
        readonly flairBadgesEnabled: boolean | null;
        readonly badges: ReadonlyArray<{
            readonly name: string;
            readonly url: string;
        }>;
    } | null;
    readonly " $refType": "AuthorBadgesContainer_settings";
};
export type AuthorBadgesContainer_settings$data = AuthorBadgesContainer_settings;
export type AuthorBadgesContainer_settings$key = {
    readonly " $data"?: AuthorBadgesContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"AuthorBadgesContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthorBadgesContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "FlairBadgeConfiguration",
            "kind": "LinkedField",
            "name": "flairBadges",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flairBadgesEnabled",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlairBadge",
                    "kind": "LinkedField",
                    "name": "badges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "url",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '794e2a3200dc2d974045a4442be1d065';
export default node;
